function getSizeToFitBars(totalBars, options, totalPadding = 20) {
    const { barThickness, barPercentage = 0.9, categoryPercentage = 0.8 } = options;
    return (barThickness * totalBars) / barPercentage / categoryPercentage + totalPadding;
}
export default getSizeToFitBars;
